// @flow
import type {DataTables} from 'datatables.net';

export default function preview(column: String, options: any,
    dtSettings: DataTables.Settings, component: JQuery) {
        dtSettings.columns.find(c => c.title == column).visible = (options == null ? false : !options);
}